import { cn } from "@/lib/utils";

interface NavMenuDotProps {
  active?: boolean;
  className?: string;
}

/** Figma menu/desktop: 6px circle, stroke only, fill transparent. */
export function NavMenuDot({ active = false, className }: NavMenuDotProps) {
  return (
    <span
      className={cn(
        "size-1.5 shrink-0 rounded-full border bg-transparent",
        active ? "border-primary" : "border-secondary",
        className
      )}
      aria-hidden
    />
  );
}
